// eslint-disable-next-line import/prefer-default-export
export const getUpsellBannerByPage = page => state => state.upsellBanner[page];
